// Pinia Store
import { defineStore } from 'pinia'

interface State {
  reloadIndex: number
}

export const useRouterStore = defineStore('router', {
  // convert to a function
  state: (): State => ({
    reloadIndex: 0,
  }),

  getters: {
    getRealoadIndex: (state) => {
      return state.reloadIndex
    },
  },

  actions: {
    incrementReloadIndex() {
      this.reloadIndex = this.reloadIndex + 1
    },
  },
})
